// extracted by css-extract-rspack-plugin
export default {"authorLinkContainer":"AuthorLink-module__authorLinkContainer__RsptC","authorNameLink":"AuthorLink-module__authorNameLink__ClG6W"};